import React from "react";
const nonAlcoholicDrinks = [{
  name: "مشاوره آنلاین (تصویری)",
  price: "۴۵ دقیقه",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/online_session_icon.png"
}, {
  name: "لغو نوبت (۲۴ ساعت قبل)",
  price: "بدون جریمه",
  logo: ""
}, {
  name: "ارزیابی اولیه روانشناختی",
  price: "۶۰ دقیقه",
  logo: ""
}, {
  name: "مشاوره اورژانسی",
  price: "۳۰ دقیقه",
  logo: ""
}, {
  name: "گزارش کتبی ارزیابی",
  price: "اختیاری",
  logo: ""
}];
const beers = [{
  name: "یادداشت‌برداری شخصی",
  price: "توصیه شده",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684933/img/notes_icon.png"
}];
export default function GrabADrink() {
  return <section data-section-id="252974" id="نکات-پیش-از-جلسه" className="bg-background text-foreground py-16 md:py-24 px-4 border-y-2 border-border">
      <div className="max-w-5xl mx-auto">
        <div className="mb-12 md:mb-16">
          <h2 className="text-5xl md:text-7xl font-default font-bold uppercase tracking-tighter text-foreground">
            نکات پیش از جلسه
          </h2>
          <div className="h-2 w-24 bg-secondary mt-4 rounded-md"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16">
          {}
          <div>
            <h3 className="text-2xl font-default font-bold uppercase mb-6 text-muted-foreground tracking-tight">
              قوانین و زمان‌بندی
            </h3>
            <div className="flex flex-col border-t-2 border-border">
              {nonAlcoholicDrinks.map((drink, i) => <div key={i} data-index={i} className="group flex justify-between items-center p-4 border-b-2 border-border hover:bg-accent hover:text-accent-foreground transition-colors duration-200 cursor-default rounded-md">
                  <div className="flex items-center gap-4">
                    {drink.logo && <img src={drink.logo} alt={`${drink.name} logo`} className="h-6 w-auto object-contain grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-200" />}
                    <span className="font-default text-lg md:text-xl font-semibold uppercase">
                      {drink.name}
                    </span>
                  </div>
                  <span className="font-default text-lg font-medium text-muted-foreground group-hover:text-accent-foreground">
                    {drink.price}
                  </span>
                </div>)}
            </div>
          </div>

          {}
          <div>
            <h3 className="text-2xl font-default font-bold uppercase mb-6 text-muted-foreground tracking-tight">
              آمادگی برای مراجع
            </h3>
            <div className="flex flex-col border-t-2 border-border">
              {beers.map((drink, i) => <div key={i} data-index={i} className="group flex justify-between items-center p-4 border-b-2 border-border hover:bg-secondary hover:text-secondary-foreground transition-colors duration-200 cursor-default rounded-md">
                  <div className="flex items-center gap-4">
                    {drink.logo && <img src={drink.logo} alt={`${drink.name} logo`} className="h-8 w-auto object-contain grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-200" />}
                    <span className="font-default text-lg md:text-xl font-semibold uppercase">
                      {drink.name}
                    </span>
                  </div>
                  <span className="font-default text-lg font-medium text-muted-foreground group-hover:text-secondary-foreground">
                    {drink.price}
                  </span>
                </div>)}
            </div>
            <div className="mt-8 p-6 bg-accent/30 rounded-lg border border-accent/50 shadow-sm">
              <p className="font-default text-sm leading-relaxed text-accent-foreground">
                یادآوری: محتوای جلسات کاملاً محرمانه است. برای جلسات آنلاین، لطفاً در محیطی آرام و با اینترنت پایدار حضور داشته باشید.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}